import { render, staticRenderFns } from "./safeCourseScore.vue?vue&type=template&id=615974d4&scoped=true"
import script from "./safeCourseScore.vue?vue&type=script&lang=js"
export * from "./safeCourseScore.vue?vue&type=script&lang=js"
import style0 from "./safeCourseScore.vue?vue&type=style&index=0&id=615974d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615974d4",
  null
  
)

export default component.exports